import React, { useState }from 'react'
import "./ExpenseForm.css"

export default function ExpenseForm(props) {
    const [ enteredTitle, setEnteredTitle ] = useState('');

    const [ enteredAmount, setEnteredAmount ] = useState('');

    const [ enteredDate, setEnteredDate ] = useState('');

    // const [userInput, setUserInput] = useState({
    //     enteredTitle: '',
    //     enteredAmount:'',
    //     enteredDate:''
    // });

    const titleChangeHandler = (event) => {
        // console.log(event.target.value)
        setEnteredTitle(event.target.value)
        // setUserInput({
        //     ...userInput,
        //     enteredTitle: event.target.value,
        // });
        // setUserInput((prevState) => {
        //     return { ...prevState, enteredTitle: event.target.value} 
        // });
    };

    const AmountChangeHandler = (event) => {
       setEnteredAmount(event.target.value)
        // setUserInput({
        //     ...userInput,
        //     enteredDate: event.target.value,
        // });
        // setUserInput( (prevState) => {
        //     return { ...prevState, enteredDate: event.target.value}
        // });

    };

    const dateChangehandler = (event) => {
        setEnteredDate(event.target.value)
        // setUserInput({
        //     ...userInput,
        //     enteredAmount: event.target.value,
        // });
        // setUserInput( (prevState) => {
        //     return { ...prevState, enteredAmount: event.target.value}
        // });
    };

    const submitHandler = (event) => {
        //// prevenDefault() --->> avoid page refresh movement
        event.preventDefault();
        const expenseData = {
            title: enteredTitle,
            amount: +enteredAmount,
            date: new Date(enteredDate)
        }
        console.log(expenseData);
        //// here we r passing data from child to parent 
        props.onSaveExpenseData(expenseData)
        //// below one for clearing all inputs of form
        setEnteredTitle('');
        setEnteredAmount('');
        setEnteredDate('');
    }
    return (
        <form onSubmit={submitHandler}>
            <div className="new-expense__controls">
                <div className="new-expense__control">
                    <label>Title</label>
                    <input 
                        type="text" 
                        value = {enteredTitle}  
                        onChange = {titleChangeHandler}
                    />
                </div>

                <div className="new-expense__control">
                    <label>Amount</label>
                    <input 
                        type="number" 
                        value = {enteredAmount} 
                        onChange = {AmountChangeHandler} 
                        min="0.01" step="0.01"
                    />
                </div>

                <div className="new-expense__control">
                    <label>Date</label>
                    <input 
                        type="date" 
                        value = {enteredDate} 
                        onChange= {dateChangehandler} 
                        min="2019-01-01" max="2022-12-31" 
                    />
                </div>

                <div className="new-actions">
                    <button type="button" onClick={props.onCancel}>Cancel</button>
                    <button type="submit" >Add Expense</button>
                </div>
            </div>
        </form>
    )
}
